import React from 'react';
import moment from 'moment-timezone';
import { CalendarIcon } from '../icons';
import './Greeting.less';

interface GreetingProps {
    firstName: string;
}

function getTimeGreeting(hour: number): string {
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
}

const Greeting = ({ firstName }: GreetingProps) => {
    const now = moment();
    const greetingLabel = getTimeGreeting(now.hour());
    const formattedDate = now.format('dddd, MMMM D, YYYY');

    const displayName = firstName?.trim() || 'there';

    return (
        <div className="greeting-card">
            <div className="greeting-label">{greetingLabel}</div>
            <div className="greeting-name">
                Welcome back,
                <br />
                {displayName}!
            </div>
            <div className="greeting-date">
                <span aria-hidden="true" style={{ display: 'inline-flex', flexShrink: 0 }}>
                    <CalendarIcon size={15} strokeWidth={2} />
                </span>
                {formattedDate}
            </div>
        </div>
    );
};

export default Greeting;
